import { Flex, Typography } from '@iheartjane/reefer';

import { ReviewStarIcons } from '@jane/bloom/components/reviewStars/reviewStars';

import styles from './productReviewsSummary.module.css';

type ProductReviewsSummaryProps = {
  aggregateRating: number;
  reviewCount: number;
  reviewPercentages: { percentage: string; rating: number }[] | undefined;
};

export function ProductReviewsSummary({
  aggregateRating,
  reviewCount,
  reviewPercentages,
}: ProductReviewsSummaryProps) {
  return (
    <div
      className={styles['pdpReviewsSummary']}
      data-testid="pdp-reviews-summary"
    >
      <Typography
        className={styles['pdpReviewsSummaryTitle']}
        variant="h2-semibold"
        color="text-main"
      >
        Customer reviews
      </Typography>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Typography variant="body-semibold" mr={8} color="text-main">
            {aggregateRating}
          </Typography>
          <ReviewStarIcons aggregateRating={aggregateRating} />
        </Flex>
        <Typography color="text-light">{reviewCount} ratings</Typography>
      </Flex>
      <Flex
        className={styles['pdpReviewsSummaryPercentages']}
        gap={24}
        flexDirection="column"
        mt={32}
      >
        {reviewPercentages?.map((review) => (
          <Flex gap={16} alignItems="center" key={review.rating}>
            <Typography color="text-main">{review.rating}&nbsp;star</Typography>
            <div className={styles['pdpReviewsPercentageBar']}>
              <div
                className={styles['pdpReviewsPercentageBarContent']}
                style={{ width: review.percentage }}
              ></div>
            </div>
            <Typography color="text-main">{review.percentage}</Typography>
          </Flex>
        ))}
      </Flex>
    </div>
  );
}
